
document.querySelectorAll('.locations-title-name').forEach(title => {
  title.addEventListener('click', function () {
    const locationClass = Array.from(this.classList).find(cls => cls.startsWith('location-'));
    
    // Exit if no matching class found
    if (!locationClass) return;

    // Remove 'active' class from all titles
    document.querySelectorAll('.locations-title-name').forEach(t => {
      t.classList.remove('active');
    });

    // Add 'active' class to the clicked title
    this.classList.add('active');

    // Check if matching block exists
    const matchedBlock = document.querySelector('.our-locations-left .' + locationClass);
    if (!matchedBlock) return;

    // Hide all blocks
    document.querySelectorAll('.our-locations-left .locations-block-loop').forEach(block => {
      block.classList.remove('active');
    });

    // Show the matched block
    matchedBlock.classList.add('active');

    // Hide .lbm-to-section
    const lbmSection = document.querySelector('.lbm-to-section');
    if (lbmSection) lbmSection.style.display = 'none';

    // Add bg-active to .our-locations-right
    const locationImg = document.querySelector('.our-locations-right');
    if (locationImg) locationImg.classList.add('bg-active');
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const searchDetails = document.querySelector('.header__search details');

  if (!searchDetails) return;

  searchDetails.addEventListener('toggle', function () {
    if (searchDetails.open) {
      document.body.classList.add('header-normal');
    } else {
      document.body.classList.remove('header-normal');
    }
  });
});


document.querySelectorAll('.product-card-wrapper').forEach(container => {
  const video = container.querySelector('.card__media video');
  container.addEventListener('mouseenter', () => {
    if (video) video.play();
  });

  container.addEventListener('mouseleave', () => {
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
$('.featured-enable-slider').slick({
  centerMode: true,
  centerPadding: '140px',
  slidesToShow: 3,
  prevArrow: $('.slick-prev-custom'),
  nextArrow: $('.slick-next-custom'),
  responsive: [
    {
      breakpoint: 990,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '50px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 750,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '35px',
        slidesToShow: 1
      }
    }
  ]
});
});


document.addEventListener("DOMContentLoaded", function () {
    const prElement = document.querySelector('product-recommendations');
    if (!prElement) return;
    const observer = new MutationObserver(function (mutationsList, observer) {
      if (prElement.innerHTML.trim().length) {

        $('.featured-enable-slider').slick({
  centerMode: true,
  centerPadding: '140px',
  slidesToShow: 3,
  prevArrow: $('.slick-prev-custom'),
  nextArrow: $('.slick-next-custom'),
  responsive: [
    {
      breakpoint: 990,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '50px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 750,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '35px',
        slidesToShow: 1
      }
    }
  ]
});

///////////////////////

/* Start code for custom option */

(() => {
  function initVariantDropdowns(container = document) {
    container.querySelectorAll('.product-card-wrapper').forEach(card => {
      if (card.dataset.dropdownInit) return; // prevent double init
      card.dataset.dropdownInit = "true";

      const optionGroups = card.querySelectorAll('.variant-option');
      const variantInput = card.querySelector('.product-variant-id');
      const addToCartBtn = card.querySelector('button[name="add"]');
      const variants = JSON.parse(card.dataset.variants);

      function getSelectedOptions() {
        return Array.from(optionGroups).map(group => {
          const label = group.querySelector('.dropdown-label');
          return label ? label.textContent.trim() : null;
        });
      }

      function updateVariant() {
        const selectedOptions = getSelectedOptions();
        const match = variants.find(v =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );
        if (!match) return;

        variantInput.value = match.id;
        const available = !!match.available;
        variantInput.disabled = !available;
        addToCartBtn.disabled = !available;
      }

      // Bind clicks
      optionGroups.forEach(group => {
        const detailsEl = group.querySelector('.dropdown');
        const label = group.querySelector('.dropdown-label');
        group.querySelectorAll('.dropdown-item').forEach(item => {
          item.addEventListener('click', e => {
            e.preventDefault();
            const value = item.dataset.value;
            label.textContent = value;

            group.querySelectorAll('.dropdown-item').forEach(li => {
              li.classList.toggle('selected', li === item);
              li.setAttribute('aria-selected', li === item ? 'true' : 'false');
            });

            detailsEl.open = false;
            updateVariant();
          });
        });
      });

      // Close dropdowns
      document.addEventListener('click', (e) => {
        if (!card.contains(e.target)) return;
        card.querySelectorAll('.dropdown[open]').forEach(d => {
          if (!d.contains(e.target)) d.open = false;
        });
      });

      updateVariant();
    });
  }

  // Run once on DOM load
  document.addEventListener("DOMContentLoaded", () => {
    initVariantDropdowns(document);
  });

  // Watch for product recommendations being injected
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          // If a <product-recommendations> itself is added
          if (node.matches("product-recommendations")) {
            initVariantDropdowns(node);
          }
          // If children are injected inside it
          if (node.closest && node.closest("product-recommendations")) {
            initVariantDropdowns(node.closest("product-recommendations"));
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


/* End code for custom option */        
 
       
        //////////////////
        observer.disconnect();
      }
    });
    observer.observe(prElement, { childList: true, subtree: true });
  });



  window.addEventListener('scroll', function () {
  if (window.scrollY > 5 && window.innerWidth < 900) {
    document.body.classList.add('scrolled-sticky');
  } else {    
    document.body.classList.remove('scrolled-sticky');
  }
});


/* Start code for custom option */

(() => {
  function initVariantDropdowns(container = document) {
    container.querySelectorAll('.product-card-wrapper').forEach(card => {
      if (card.dataset.dropdownInit) return; // prevent double init
      card.dataset.dropdownInit = "true";

      const optionGroups = card.querySelectorAll('.variant-option');
      const variantInput = card.querySelector('.product-variant-id');
      const addToCartBtn = card.querySelector('button[name="add"]');
      const variants = JSON.parse(card.dataset.variants);

      function getSelectedOptions() {
        return Array.from(optionGroups).map(group => {
          const label = group.querySelector('.dropdown-label');
          return label ? label.textContent.trim() : null;
        });
      }

      function updateVariant() {
        const selectedOptions = getSelectedOptions();
        const match = variants.find(v =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );
        if (!match) return;

        variantInput.value = match.id;
        const available = !!match.available;
        variantInput.disabled = !available;
        addToCartBtn.disabled = !available;
      }

      // Bind clicks
      optionGroups.forEach(group => {
        const detailsEl = group.querySelector('.dropdown');
        const label = group.querySelector('.dropdown-label');
        group.querySelectorAll('.dropdown-item').forEach(item => {
          item.addEventListener('click', e => {
            e.preventDefault();
            const value = item.dataset.value;
            label.textContent = value;

            group.querySelectorAll('.dropdown-item').forEach(li => {
              li.classList.toggle('selected', li === item);
              li.setAttribute('aria-selected', li === item ? 'true' : 'false');
            });

            detailsEl.open = false;
            updateVariant();
          });
        });
      });

      // Close dropdowns
      document.addEventListener('click', (e) => {
        if (!card.contains(e.target)) return;
        card.querySelectorAll('.dropdown[open]').forEach(d => {
          if (!d.contains(e.target)) d.open = false;
        });
      });

      updateVariant();
    });
  }

  // Run once on DOM load
  document.addEventListener("DOMContentLoaded", () => {
    initVariantDropdowns(document);
  });

  // Watch for product recommendations being injected
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          // If a <product-recommendations> itself is added
          if (node.matches("product-recommendations")) {
            initVariantDropdowns(node);
          }
          // If children are injected inside it
          if (node.closest && node.closest("product-recommendations")) {
            initVariantDropdowns(node.closest("product-recommendations"));
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


/* End code for custom option */


// product-card-wrapper-catring

(() => {

  function initProductVariants() {
    document.querySelectorAll('.product-card').forEach(card => {

      if (card.dataset.variantInit) return;
      card.dataset.variantInit = 'true';

      const variants = JSON.parse(card.dataset.variants || '[]');
      const groups   = card.querySelectorAll('.variant-group');

      if (!variants.length || !groups.length) return;

      const getSelectedOptions = () =>
        Array.from(groups).map(group =>
          group.querySelector('.variant-label')?.textContent.trim()
        );

      const resetQuantity = () => {
        const qtyInput = card.querySelector('.qty-input');
        if (qtyInput) {
          qtyInput.value = 0;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      const updateVariantId = () => {
        const selectedOptions = getSelectedOptions();

        const matchedVariant = variants.find(variant =>
          variant.options.every((opt, i) => opt === selectedOptions[i])
        );

        if (!matchedVariant) return;

        card.setAttribute('data-variant-id', matchedVariant.id);
        resetQuantity(); // 🔥 reset qty
      };

      groups.forEach(group => {
        const dropdown = group.querySelector('.variant-dropdown');
        const label    = group.querySelector('.variant-label');

        group.querySelectorAll('.variant-item').forEach(item => {
          item.addEventListener('click', e => {
            e.preventDefault();

            label.textContent = item.dataset.value;

            group.querySelectorAll('.variant-item').forEach(el => {
              el.classList.remove('is-selected');
              el.setAttribute('aria-selected', 'false');
            });

            item.classList.add('is-selected');
            item.setAttribute('aria-selected', 'true');

            dropdown.open = false;
            updateVariantId();
          });
        });
      });

      updateVariantId();
    });
  }

  document.addEventListener('DOMContentLoaded', initProductVariants);

  

})();



document.addEventListener('click', function (e) {
  document.querySelectorAll('.variant-dropdown[open]').forEach(function (details) {
    if (!details.contains(e.target)) {
      details.removeAttribute('open');
    }
  });
});